import { useEffect, useState } from "react";

const VALID_INDICATORS = ["none", "minor", "major", "critical"] as const;
type StatusIndicator = (typeof VALID_INDICATORS)[number];

interface AirtableStatus {
	indicator: StatusIndicator | null;
	description: string;
}

const POLL_INTERVAL = 60_000;

export function useAirtableStatus(): AirtableStatus {
	const [status, setStatus] = useState<AirtableStatus>({ indicator: null, description: "Loading..." });

	useEffect(() => {
		const fetchStatus = async () => {
			try {
				const res = await fetch("https://status.airtable.com/api/v2/status.json");
				if (!res.ok) return;
				const data = await res.json();
				const indicator = VALID_INDICATORS.includes(data.status?.indicator) ? data.status.indicator : null;
				setStatus({
					indicator,
					description: data.status?.description ?? "Unknown",
				});
			} catch {
				setStatus({ indicator: null, description: "Unable to fetch status" });
			}
		};

		fetchStatus();
		const interval = setInterval(fetchStatus, POLL_INTERVAL);
		return () => clearInterval(interval);
	}, []);

	return status;
}
